import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './dashboard.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { SharedModule } from '../../shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import {NgApexchartsModule} from 'ng-apexcharts';
import {PipesModule} from '../../shared/pipes/pipes.module';

@NgModule({
  declarations: [DashboardComponent],
    imports: [
        NgbModule,
        CommonModule,
        DashboardRoutingModule,
        SharedModule,
        NgxChartsModule,
        ReactiveFormsModule,
        NgApexchartsModule,
        PipesModule
    ]
})
export class DashboardModule { }
